<template>
  <div class="calendar-app container--large">
    <!--    <ResultsListDisplayOptions></ResultsListDisplayOptions>-->
    <CalendarTimeZoneSelector @newTimeZoneSelected="handleTimeZone">
    </CalendarTimeZoneSelector>
    <FullCalendar :options="calendarOptions">
      <template v-slot:eventContent='arg'>
        <b v-if="!arg.event.extendedProps.isMultiDay">
          <template v-if="arg.event.extendedProps.isTBD && !isEyeOnEquityEvent(arg.event.extendedProps)">
            TBD
          </template>
          <template v-else-if="arg.timeText && !isEyeOnEquityEvent(arg.event.extendedProps)">
            {{ arg.timeText }}
          </template>
        </b> <i>{{ arg.event.title }}</i>
      </template>
      <!--    <template v-slot:eventContent='arg'>-->
      <!--      <CalendarItem :event="arg"></CalendarItem>-->
      <!--    </template>-->
    </FullCalendar>
    <CalendarModal
      :show-modal="showModal"
      :time-zone="timeZone"
      :event="currentEvent"
      :raw-event="rawEvent"
      @modalClosed="closeModal"
    ></CalendarModal>
  </div>
</template>

<script>
import '@fullcalendar/core/vdom'; // Solves problem with Vite. Import first.
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list'; // Not recommending we use this.
import CalendarItem from '@/components/CalendarItem';
import CalendarModal from '@/components/CalendarModal';
import CalendarTimeZoneSelector from '@/components/CalendarTimeZoneSelector';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import { mapGetters } from 'vuex';
import moment from 'moment';
import calendar from '@/mixins/calendar'

const searchSettings = window.drupalSettings.searchSettings

export default {
  name: 'Calendar',
  mixins: [calendar],
  components: {
    CalendarTimeZoneSelector,
    // ResultsListDisplayOptions,
    CalendarModal,
    CalendarItem,
    FullCalendar,
  },
  data: function () {
    return {
      currentEvent: {},
      currentEvents: [],
      showModal: false,
      timeZone: searchSettings[this.$route.name].default_timezone || 'US/Pacific',
      rawEvent: {},
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      resultsItems: 'getResultsItems',
    }),
    events() {
      return this.resultsItems.map((item) => {
        return {
          id: item.external_id,
          title: item.title,
          start: this.startDateTime(item),
          allDay: false,
          displayEventEnd: !!item.end_date_and_time_1, // @TODO test
          end: this.endDateTime(item),
          extendedProps: {
            // @TODO multiple dates and times
            event_count: item.event_count,
            event_type: item.event_type,
            event_type_friendly: item.event_type_friendly,
            start_date_and_time_1: item.start_date_and_time_1,
            start_date_date_only_1: item.start_date_date_only_1,
            end_date_and_time_1: item.end_date_and_time_1,
            event_conclusion_date_and_time: item.event_conclusion_date_and_time,
            image: item.image,
            image_alt: item.image_alt,
            is_ra: item.is_ra,
            location_1: item.location_1,
            location_2: item.location_2,
            region: item.region,
            summary: item.summary,
            path: item.path,
            isTBD: this.isTBD(item),
            isMultiDay: this.isMultiDay(item)
          },
        };
      });
    },
    calendarOptions() {
      return {
        timeZone: this.timeZone,
        plugins: [
          dayGridPlugin,
          momentTimezonePlugin,
          interactionPlugin, // needed for dateClick
        ],
        contentHeight: 'auto',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: '',
        },
        initialView: 'dayGridMonth',
        editable: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: 3,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        views: {
          dayGridMonth: {
            fixedWeekCount: false,
          },
        },
        eventSources: [
          {
            events: this.events,
          },
        ],
        datesSet: this.handleDatesSet,
      };
    },
  },
  methods: {
    isTBD(item) {
      return item.start_date_and_time_1 === undefined;
    },
    isMultiDay(item) {
      if(item.end_date_and_time_1 !== undefined) {
        return moment(String(item.start_date_and_time_1 ? item.start_date_and_time_1 : item.start_date_date_only_1)).format('L') !== moment(String(item.end_date_and_time_1)).format('L')
      }
      return false;
    },
    startDateTime(item) {
      return item.start_date_and_time_1 ? item.start_date_and_time_1 : item.start_date_date_only_1.slice(0, 10);
    },
    endDateTime(item) {
      if (this.isTBD(item) && item.end_date_and_time_1) {
        // Add a day to make sure that TBD events end on the proper day in the
        // calendar view.
        return moment(item.end_date_and_time_1).add(1, 'days').format()
      }
      return item.end_date_and_time_1
    },
    handleTimeZone(selectedTimeZone) {
      this.timeZone = selectedTimeZone;
    },
    handleDateSelect(selectInfo) {
    },
    handleEventClick(e) {
      this.rawEvent = e;
      this.currentEvent = e.event;
      this.showModal = true;
      document.querySelector(".fc-more-popover").style.display = "none";
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    handleDatesSet(datesSet) {
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style>
/* This reference needs to be updated whenever we update fullcalendar */
/* See https://www.jsdelivr.com/package/npm/fullcalendar */
@import 'https://cdn.jsdelivr.net/npm/fullcalendar@5.10.1/main.min.css';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
